export const BookEnum = Object.freeze({
  bundle: 'book_bundle1',
  ultimate: 'book1',
  accent: 'book2',
  charisma: 'book3',
})